document.addEventListener("DOMContentLoaded", (event) => {
  /*document.querySelectorAll("*").forEach((element) => {
    element.addEventListener("focus", function(event) {
        console.log("Focus Element");
        console.log(event.target);
    });
  });*/

  /*let linkedSlideShows = document.querySelectorAll(".linked-mini-blocks");
  if (linkedSlideShows) {
    linkedSlideShows.forEach((slideshow) => {
      let section = slideshow.closest(".shopify-section.section.slideshow-banner-section");
      let slideDots = slideshow.querySelectorAll(".slider-counter.slider-counter--dots .slider-counter__link.slider-counter__link--dots");
      let index = 0;
      let miniBlockSection = section.nextElementSibling;
      let miniBlocks = miniBlockSection.querySelectorAll(".mini-block");
      if (miniBlockSection && slideDots && miniBlocks) {
        slideDots.forEach((dot, index) => {
          if (dot.classList.contains("slider-counter__link--active")) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            if (miniBlocks[index]) {
              miniBlocks[index].classList.remove("mini-block--active");
            }
          }
        });
      }

      slideshow.addEventListener("slideChanged", function(event) {
        let newIndex = event.detail.currentPage - 1;
        miniBlocks.forEach((block, index) => {
          if (index == newIndex) {
            miniBlocks[index].classList.add("mini-block--active");
          } else {
            miniBlocks[index].classList.remove("mini-block--active");
          }
        });

      }); 
    });
  }*/

  let rivoCustomer = false;
  const rivoHeartIcon = document.querySelector('.rivo-favorites-icon');
  function isRivoCustomer() {
    RivoJS.getCustomerDetails().then(function(resp){
      if(resp != null) {
        console.log("Customer is logged in.");
        rivoCustomer = true;
        rivoHeartIcon.classList.add('active');
      } else {
        console.log("Customer is not logged in.");
        rivoCustomer = false;
        rivoHeartIcon.classList.remove('active');
      }
    });
  }

  // Check if Rivo Exists
  if (window.RivoJS) {
    isRivoCustomer();
    initRivoQuickview();
  } else {  
    document.addEventListener("rivo-js-loaded", function(){
      isRivoCustomer();
      initRivoQuickview();
    });
  }

  function initRivoQuickview() {
    document.addEventListener("quickAddContentLoaded", function(event) {
      const quickAddActiveRivo = event.detail.currentModal;
      const quickAddActiveProductId = event.detail.currentModal.id;
      const quickAddActiveId = quickAddActiveProductId.split("-")[1];
      const rivoButton = quickAddActiveRivo.querySelector('rivo-favorite-button');
      const rivoSuccess = document.querySelector('.rivo-aw-success');
      const rivoSuccessMessage = document.querySelector('.rivo-aw-toast-message');
      const rivoSuccessButton = document.querySelector('.rivo-aw-toast-button');
      const rivoSuccessMessageAttributes = {
        'aria-label': 'View favorites',
        'data-action-type': 'added_to_favorites'
      }
      let rivoProductMatch = false;

      // Add to Favorites
      if (quickAddActiveRivo){
        rivoButton.removeAttribute("style");
        rivoButton.addEventListener("click", function() {
          window.getFavoriteProducts().then(function(resp){
            window.RivoJS.addFavoriteProduct(quickAddActiveId).then(function(resp) {
              quickAddActiveRivo.hide();
              if (!rivoCustomer){
                window.location.href = window.location.href + "#rivo-favorites";
              }
            });
          });
          if (rivoCustomer){
            rivoSuccess.classList.add('rivo-aw-show');
            rivoSuccess.style.display = "flex";
            rivoSuccessMessage.textContent = "Item Saved";
            rivoSuccessButton.style.display = "block";
            rivoSuccessButton.textContent = "View Favorites";
            for (const key in rivoSuccessMessageAttributes) {
              rivoSuccessButton.setAttribute(key, rivoSuccessMessageAttributes[key]);
            }
            setTimeout(() => {
              rivoSuccess.style.display = 'none';
            }, 3000);
          }
        });
      } 

      // Check if favorite product exists
      async function isProductInRivoFavorites() {
        try {
          const favoriteProducts = await RivoJS.getFavoriteProducts();
          for (let product of favoriteProducts.products){
            const productMatch = product.remote_id;
            if (productMatch == quickAddActiveId) {
              rivoProductMatch = true;
            }
            if (rivoProductMatch){
              rivoButton.classList.add("rivo-favorite-active");
              rivoButton.addEventListener("click", function() {
                window.getFavoriteProducts().then(function(resp){
                  window.RivoJS.removeFavoriteProduct(quickAddActiveId).then(function(resp) {
                    quickAddActiveRivo.hide();
                    if (!rivoCustomer){
                      window.location.href = window.location.href + "#rivo-favorites";
                    }
                  });
                });
                if (rivoCustomer){
                  rivoSuccess.classList.add('rivo-aw-show');
                  rivoSuccess.style.display = "flex";
                  rivoSuccessMessage.textContent = "Item Removed";
                  rivoSuccessButton.style.display = "none";
                  rivoSuccessButton.textContent = "";
                  for (const key in rivoSuccessMessageAttributes) {
                    rivoSuccessButton.removeAttribute(key, rivoSuccessMessageAttributes[key]);
                  }
                  setTimeout(() => {
                    rivoSuccess.style.display = 'none';
                  }, 3000);
                }
              });
            }
          }
        } catch (error) {
          console.error("Error retrieving Rivo favorite products:", error);
        } 
        return false;
      } isProductInRivoFavorites();

    });
  }
});